import { createTheme } from '@mui/material/styles';
import lightPalette from './lightPalette';
import darkPalette from './darkPalette';
import typography from './typography';
import components from './components';

export const muiTheme = isDark =>
  createTheme({
    palette: isDark
      ? { mode: 'dark', ...darkPalette }
      : { mode: 'light', ...lightPalette },
    typography,
    components,
    shape: { borderRadius: '6px' },
  });
